import { render } from "./Transcript.vue?vue&type=template&id=bac97a5c&scoped=true"
import script from "./Transcript.vue?vue&type=script&lang=js"
export * from "./Transcript.vue?vue&type=script&lang=js"

import "./Transcript.vue?vue&type=style&index=0&id=bac97a5c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac97a5c"]])

export default __exports__